"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAemConfiguration = void 0;
const setConfigGetter = (config, name, getter) => {
    Object.defineProperty(config, name, { get: getter });
};
const generateAemConfiguration = (aemConfig) => {
    const config = Object.assign({}, aemConfig);
    setConfigGetter(config, 'defaultRequestParams', function () {
        return {
            shopId: this.fictiveWebShop,
            market: this.market,
            mainWebshop: this.mainWebShop,
            language: this.lang,
            anaLang: this.languageAnalytics,
        };
    });
    setConfigGetter(config, 'servicesEndpoint', function () {
        return this.services.api;
    });
    setConfigGetter(config, 'pdpTemplateName', function () {
        return this.pageInfo.pdpTemplateName;
    });
    setConfigGetter(config, 'placeholderVat', function () {
        return this.placeholders.vat;
    });
    setConfigGetter(config, 'buyDelivery', function () {
        return this.buy.delivery;
    });
    setConfigGetter(config, 'fredHopperSearchUrl', function () {
        return this.services.fredHopper.search;
    });
    setConfigGetter(config, 'oneSizeProductCode', function () {
        return this.product.code.oneSize;
    });
    setConfigGetter(config, 'authenticationConfig', function () {
        return {
            anaLang: this.languageAnalytics,
            fictiveWebShop: this.fictiveWebShop,
            locale: this.lang,
            mainWebshop: this.mainWebShop,
            market: this.market,
        };
    });
    setConfigGetter(config, 'socialEnabledList', function () {
        return this.thirdparty.socialLogin.enabledList;
    });
    setConfigGetter(config, 'applePayMerchantId', function () {
        return this.thirdparty.applePay.merchantId;
    });
    setConfigGetter(config, 'saferpayConfig', function () {
        return this.thirdparty.saferpay;
    });
    setConfigGetter(config, 'klarnaConfig', function () {
        return this.thirdparty.klarna;
    });
    setConfigGetter(config, 'productImageConfig', function () {
        return this.product.images;
    });
    setConfigGetter(config, 'productSwatchConfig', function () {
        return this.product.swatch;
    });
    return config;
};
exports.generateAemConfiguration = generateAemConfiguration;
//# sourceMappingURL=AemConfigurationUtils.js.map